import { render, staticRenderFns } from "./companyCheck2.vue?vue&type=template&id=5f65a25a&scoped=true"
import script from "./companyCheck2.vue?vue&type=script&lang=js"
export * from "./companyCheck2.vue?vue&type=script&lang=js"
import style0 from "./companyCheck2.vue?vue&type=style&index=0&id=5f65a25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f65a25a",
  null
  
)

export default component.exports